import React, { useEffect, useState } from 'react';
import { MERCHANT_TYPE, MERCHANT_TAG } from '../../common/constants';
import { Card, Row, Col, Space, Table } from 'antd';

// 商家信息
function MerchantInfo(props: any) {
    const { merchantInfo } = props || {};
    const [dataSource, setDataSource] = useState([]);
    const { 
        name,
        kind,
        commissionRate,
        tags, 
        acceptedPayment,
        origin,
        shippingOrigins,
        directShipping,
        forwardConfig,
        domesticShipping,
        internationalShipping,
        unavailableAddresses,
        directToUserAreas
    } = merchantInfo || {};
    const shippingFee = !domesticShipping?.disable ? domesticShipping : 
                        !internationalShipping?.disable ? internationalShipping : null;

    useEffect(() => {
        if(shippingFee) {
            let data = [];
            const { edges, costs, shippingCurrency } = shippingFee || {};
            data = edges?.map((edge, index) => {
                const isLast = index === edges?.length - 1;
                return {
                    range: `${edge} ~ ${isLast ? '∞' : edges[index + 1]}`,
                    fee: costs[index]
                }
            });
            setDataSource(data);
        }
    }, [shippingFee]);

    const columns= [{
        title: `范围(${shippingFee?.shippingCurrency})`,
        dataIndex: 'range',
        key: 'range',
    }, {
        title: `运费(${shippingFee?.shippingCurrency})`,
        dataIndex: 'fee',
        key: 'fee',
    }];

    if(!merchantInfo) return null;
    return (
        <Card title="商家信息" style={{ width: '100%' }}>
            <Space direction="vertical" size='middle' style={{ width: '100%' }}>
                <Row>商家名称：{name}</Row>
                <Row>
                    <Col span={8}>商家类型：{MERCHANT_TYPE[kind] || kind}</Col>
                    <Col span={8}>商家默认佣金：{commissionRate ? `${(commissionRate?.commissionRate * 100).toFixed(2)}%` : '-'} </Col>
                    <Col span={8}>商家tag：{tags?.map(item => ((MERCHANT_TAG[item]) || item))?.join('，')}</Col>
                </Row>
                <Row>支持支付方式：{acceptedPayment?.join('，')}</Row>
                <Row>
                    不支持购买地区：
                    <Space direction="vertical">
                        {unavailableAddresses?.map(item => {
                            return <span>{item?.country}/{item?.state}/{item?.city}/{item?.district}</span>
                        })}
                    </Space>
                </Row>
                <Row>商家所属地区：{origin}</Row>
                <Row>商家发货地：{shippingOrigins?.join('，')}</Row>
                {directToUserAreas && directToUserAreas.length ? <Row>支持非中国大陆收件地址：{directToUserAreas?.map(item => `${item?.country}${item?.state ? '/' + item?.state : ''}`)?.join('、')}</Row> : null}
                <Row>中国大陆地址收货方式：{directShipping ? '直发用户' : `仓库转运 转运仓库：${forwardConfig?.type}：${forwardConfig?.value?.join('，')}`}</Row>
                {!directShipping && <Row>注：个别商家虽然配置了转运仓库，也会直发给用户</Row>}
                {shippingFee && <Row>
                    <Col span={2}>商家运费：</Col>
                    <Col span={6}>
                    <Table
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false}
                    />
                    </Col>
                </Row>}
            </Space>
        </Card>
    )
}

export default MerchantInfo;